import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Download } from '../interfaces/download.interface';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class ReportingService {
  public constructor(private readonly api: ApiService) {}

  public generateOrderResultsReport(organisationId: string, orderId: string, admin?: boolean): Observable<Download>{
    const path: string = admin ? `admin/organisations/${organisationId}/reporting/orders/${encodeURIComponent(orderId)}/results`
      :  `organisations/${organisationId}/reporting/orders/${encodeURIComponent(orderId)}/results`;

    return this.api.post<Download, object>( path, {} );
  }
}
